import { useContext } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { Col, Modal, Row } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import { FaEthereum, FaTimes } from "react-icons/fa";
import SolanaIcon from "./SolanaIcon";
import OptionListTile from "./OptionListTile";
import IconButton from "./IconButton";
import { Center } from "./Center";
import { SizedBox } from "./SizedBox";
import { TitleText } from "./TitleText";
import { useAppColors } from "../utils/useAppColors";
import { Web3Context } from "../contexts/Web3Context";

// Lets the user pick which chain to connect with, then kicks off the matching
// login flow (EVM MetaMask `login` or Solana wallet-adapter `loginSolana`).
export default function ChainSelectModal({ open, setOpen }) {
  const { login, loginSolana } = useContext(Web3Context);
  const colors = useAppColors();

  const chooseEthereum = () => {
    setOpen(false);
    login();
  };

  const chooseSolana = () => {
    setOpen(false);
    loginSolana();
  };

  const options = (
    <div style={{ width: "90%" }}>
      <SizedBox height={8} />
      <TitleText textAlign={"start"}>Connect with</TitleText>
      <SizedBox height={20} />
      <OptionListTile
        onClick={chooseEthereum}
        name={"Ethereum"}
        Icon={FaEthereum}
      />
      <hr color={colors.textFieldColor} />
      <OptionListTile onClick={chooseSolana} name={"Solana"} Icon={SolanaIcon} />
      <SizedBox height={20} />
    </div>
  );

  return (
    <>
      <BrowserView>
        <Modal
          dialogClassName="modal-60w"
          show={open}
          onHide={() => setOpen(false)}
        >
          <Modal.Body>
            <Center>
              <div style={{ width: "90%" }}>
                <SizedBox height={8} />
                <Row className="d-flex align-items-end justify-content-end">
                  <Col className="d-flex align-items-end justify-content-end">
                    <IconButton Icon={FaTimes} onClick={() => setOpen(false)} />
                  </Col>
                </Row>
                {options}
              </div>
            </Center>
          </Modal.Body>
        </Modal>
      </BrowserView>
      <MobileView>
        <BottomSheet open={open} onDismiss={() => setOpen(false)}>
          <Center>{options}</Center>
          <SizedBox height={32} />
        </BottomSheet>
      </MobileView>
    </>
  );
}
